import { gql, useMutation } from '@apollo/client';
import { USERVALUE_FIELDS, UserValue } from '@dieterApi/persistentState/useUserValuesQuery';
const DELETE_USER_VALUE = gql`
  ${USERVALUE_FIELDS}
  mutation DeleteUserValue($key: String!, $index: String, $value: String) {
    deleteUserValue(key: $key, value: $value, index: $index) {
      ...UserValueFields
    }
  }
`;

export interface UserValueDeleteInput {
  key: string;
  value?: string;
  index?: string;
}

export interface UserValueDeleteResult {
  deleteUserValue: UserValue | null; // null when the row did not exist
}

export interface UserValueDeleteContext {
  userId: string;
}

export function useUserValueDeleteMutation() {
  return useMutation<UserValueDeleteResult, UserValueDeleteInput, UserValueDeleteContext>(DELETE_USER_VALUE, {
    // refetchQueries: ['GetUserValues'],
    update: (cache, { data }) => {
      const id = data?.deleteUserValue?.id;
      if (!id) return;
      cache.evict({ id: `UserValue:${id}` });
    },
  });
}
